import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import usePageTracking from './usePageTracking';
import routes from './routes';
import Navbar from "./components/Navbar";
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import VisitorSurvey from './components/VisitorSurvey';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <PageTrackingWrapper />
    </Router>
  );
}

const PageTrackingWrapper = () => {
  usePageTracking();

  return (
    <div className="app-shell">
      <Navbar />
      <main className="app-main">
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </main>
      <Footer />
      <VisitorSurvey />
    </div>
  );
}

export default App;
